import qrLogin from './qrLogin';
import qrSecKey from './qrSecKey';

const mchChild = [
    qrSecKey,
    qrLogin
];

export default mchChild;
